<template>
  <transition name="MoveRightIn">
    <div class="x_drawer_main" v-show="visible">
      <border-title slot="title" :title="title" :isShowClose="true" @close="close" class="margin-bottom-20" />
      <div class="content">
        <slot></slot>
      </div>
      <footer :class="['flex', 'align-items-center', { 'border_top': footerBorder}]" v-if="isShowFooter">
        <slot name="footer"></slot>
      </footer>
    </div>
  </transition>
</template>
<script>
export default {
  data () {
    return {
      rendered: false
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    // 控制显示
    visible: {
      type: Boolean,
      default: false
    },
    // 是否显示尾部
    isShowFooter: {
      type: Boolean,
      default: false
    },
    // 关闭的时候是否销毁表单等实列 （让表单回到初始状态）
    destroyOnClose: {
      type: Boolean,
      default: false
    },
    // 尾部是否用上边线
    footerBorder: {
      type: Boolean,
      default: true
    }
  },
  /* mounted () {
    // 挂载的时候让内容组件显示 回到初始状态
    if (this.visible) {
      this.rendered = true
    }
  }, */
  methods: {
    // 进行关闭
    close () {
      this.$emit('close')
      this.$emit('update:visible', false)
      // if (this.destroyOnClose === true) {
      //   this.rendered = false
      // }
    }
  }
  /* watch: {
    visible (val) {
      if (val) {
        this.rendered = true
      } else {
        this.$emit('close')
        if (this.destroyOnClose === true) {
          this.rendered = false
        }
      }
    }
  } */
}
</script>
<style lang="scss" scoped>
  .x_drawer_main {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 50px;
    bottom: 0px;
    right: 0px;
    width: 70%;
    background-color: white;
    padding: 0 20px;
    box-shadow:0px 0px 6px 0px rgba(53,53,53,0.15);
    overflow: auto;
    z-index: 1910;
    .content {
      flex: 1;
      overflow: auto;
    }
    & > footer {
      height: 50px;
      &.border_top {
        border-top: 1px solid $border-color-base;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/drawer/x-drawer.vue